/**
 * Icones padrao do Leaflet servidos pela propria aplicacao (assets/leaflet/, copiados de
 * node_modules/leaflet/dist/images pelo angular.json). Evita depender de CDN externo (unpkg)
 * para o marcador dos mapas.
 */
export const LEAFLET_ICONES = {
  iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
  iconUrl: 'assets/leaflet/marker-icon.png',
  shadowUrl: 'assets/leaflet/marker-shadow.png',
} as const;

/** Aponta os icones padrao do Leaflet para os assets locais. `L` e o modulo carregado via import('leaflet'). */
export function corrigirIconesLeaflet(L: any): void {
  const iconDefault = L?.Icon?.Default;
  if (!iconDefault) return;
  iconDefault.mergeOptions({ ...LEAFLET_ICONES });
}
